module.exports = __webpack_public_path__ + "assets/img/flag-hk.faf09d0d.svg";